import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import moment from "moment";
import { firstValueFrom } from "rxjs";

@Pipe({
    name: "setProjectFilterDate",
    standalone: false,
})
export class SetProjectFilterDatePipe implements PipeTransform {
    constructor(public translateService: TranslateService) {}

    async transform(value: string, args?: any) {
        if (value) {
            const today = moment().startOf("day");
            const tomorrow = moment().add(1, "days").startOf("day");
            const valueDate = moment(new Date(value));
            if (!valueDate.isValid()) {
                return "";
            }
            const date = valueDate.startOf("day");
            const translations = await firstValueFrom(this.translateService.get("EVENT"));

            if (today.diff(date) === 0) {
                return translations.TODAY;
            }

            if (tomorrow.diff(date) === 0) {
                return translations.TOMORROW;
            }

            return `${date.date()}. ${await this.setMonth(date.month())} ${date.year()}`;
        }

        return "";
    }

    public setMonth = async (digitMonth: number): Promise<string> => {
        let month: string = null;

        await this.translateService
            .get("MONTHS")
            .subscribe((data) => {
                switch (digitMonth) {
                    case 0:
                        month = data.JANUARY;
                        break;
                    case 1:
                        month = data.FEBRUARY;
                        break;
                    case 2:
                        month = data.MARCH;
                        break;
                    case 3:
                        month = data.APRIL;
                        break;
                    case 4:
                        month = data.MAY;
                        break;
                    case 5:
                        month = data.JUNE;
                        break;
                    case 6:
                        month = data.JULY;
                        break;
                    case 7:
                        month = data.AUGUST;
                        break;
                    case 8:
                        month = data.SEPTEMBER;
                        break;
                    case 9:
                        month = data.OCTOBER;
                        break;
                    case 10:
                        month = data.NOVEMBER;
                        break;
                    case 11:
                        month = data.DECEMBER;
                        break;
                }
            })
            .unsubscribe();

        return month;
    };

    public setDay = async (day: string): Promise<string> => {
        if (day.indexOf("0") === 0) {
            return day.replace("0", "");
        }

        return day;
    };
}
